import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import bg1 from "../../assets/image/service-icon-01.png";
import bg2 from "../../assets/image/service-icon-02.png";
import bg3 from "../../assets/image/service-icon-03.png";

import { Pagination } from "swiper/modules";
import "swiper/css/pagination";

import video from "../../assets/image/course-video.mp4";
import { Fragment } from "react";

const HomeSlider = () => {
  return (
    <Fragment>
      <section className="section main-banner" id="top" data-section="section1">
        <video autoPlay muted loop id="bg-video">
          <source src={video} type="video/mp4" />
        </video>

        <div className="video-overlay header-text">
          <div className="container mainCption">
            <div className="row">
              <div className="col-lg-12 d-flex align-items-center">
                <div className="caption">
                  <h6>Hello Students</h6>
                  <h2>Welcome to Education</h2>
                  <p>
                    This is an edu meeting HTML CSS template provided by{" "}
                    <Link>Student Education</Link>
                    As a new student, you’ll need to learn a lot of new
                    information pretty fast or risk being clueless, penniless,
                    and more than a bit confused about independent student life.
                    <Link>Pressmaster</Link>.
                  </p>
                  <div className="main-button-red">
                    <div className="scroll-to-section">
                      <a href="#contact">Join Us Now!</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services">
        <div className="container ">
          <div className="row">
            <div className="col-lg-12">
              <Swiper
                modules={[Pagination]}
                spaceBetween={30}
                pagination={{ clickable: true }}
                breakpoints={{
                  768: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}
                loop={true}
              >
                <SwiperSlide className="item">
                  <div className="icon">
                    <img src={bg1} alt="" />
                  </div>
                  <div className="down-content">
                    <h4>Best Education</h4>
                    <p>
                      Suspendisse tempor mauris a sem elementum bibendum.
                      Praesent facilisis massa non vestibulum.
                    </p>
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div className="icon">
                    <img src={bg2} alt="" />
                  </div>
                  <div className="down-content">
                    <h4>Best Teachers</h4>
                    <p>
                      Suspendisse tempor mauris a sem elementum bibendum.
                      Praesent facilisis massa non vestibulum.
                    </p>
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div className="icon">
                    <img src={bg3} alt="" />
                  </div>
                  <div className="down-content">
                    <h4>Best Students</h4>
                    <p>
                      Suspendisse tempor mauris a sem elementum bibendum.
                      Praesent facilisis massa non vestibulum.
                    </p>
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div className="icon">
                    <img src={bg2} alt="" />
                  </div>
                  <div className="down-content">
                    <h4>Online Meeting</h4>
                    <p>
                      Suspendisse tempor mauris a sem elementum bibendum.
                      Praesent facilisis massa non vestibulum.
                    </p>
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div className="icon">
                    <img src={bg3} alt="" />
                  </div>
                  <div className="down-content">
                    <h4>Best Networking</h4>
                    <p>
                      Suspendisse tempor mauris a sem elementum bibendum.
                      Praesent facilisis massa non vestibulum.
                    </p>
                  </div>
                </SwiperSlide>

                <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div>
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default HomeSlider;
